module.exports = __webpack_public_path__ + "static/img/Blayke-Brailey.6d46ed7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Blayke-Brailey.jpg
// module id = IDp2
// module chunks = 0